import { schedule } from '../../data/landingData';
import { Calendar, Clock, Check } from 'lucide-react';

export const Schedule = () => {
  return (
    <section 
      id="schedule" 
      className="py-24 px-6 bg-[#111111]"
      data-testid="schedule-section"
    >
      <div className="max-w-5xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-16">
          <p className="text-[#D4AF37] font-manrope uppercase tracking-[0.2em] text-xs font-bold mb-4">
            The Journey
          </p>
          <h2 className="font-cormorant text-4xl md:text-5xl font-medium text-white mb-4">
            4-Day, 3-Night Journey
          </h2>
          <p className="text-zinc-400 font-manrope max-w-2xl mx-auto">
            A carefully crafted experience for deep transformation
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Center line - desktop only */}
          <div className="hidden md:block timeline-line" />

          {/* Schedule items */}
          <div className="space-y-12 md:space-y-0">
            {schedule.map((day, index) => (
              <div
                key={index}
                className={`relative md:flex items-start gap-8 ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                } ${index > 0 ? 'md:mt-16' : ''}`}
                data-testid={`schedule-day-${day.day}`}
              >
                {/* Content card */}
                <div className={`flex-1 ${index % 2 === 0 ? 'md:text-right md:pr-12' : 'md:pl-12'}`}>
                  <div className={`bg-[#0A0A0A] border border-white/5 rounded-2xl p-8 hover:border-[#D4AF37]/30 transition-colors ${
                    index % 2 === 0 ? 'md:ml-auto' : ''
                  }`}>
                    {/* Day number */}
                    <div className={`flex items-center gap-3 mb-4 ${index % 2 === 0 ? 'md:justify-end' : ''}`}>
                      <div className="w-10 h-10 rounded-full bg-[#D4AF37]/10 flex items-center justify-center">
                        <span className="text-[#D4AF37] font-manrope font-bold">{day.day}</span>
                      </div>
                      <div className="flex items-center gap-2 text-zinc-500 font-manrope text-sm">
                        <Clock className="w-4 h-4" />
                        {day.time}
                      </div>
                    </div>

                    {/* Title */}
                    <h3 className="font-cormorant text-2xl font-medium text-white mb-2">
                      {day.title}
                    </h3>
                    <p className="text-[#D4AF37] font-manrope text-sm mb-4">
                      {day.subtitle}
                    </p>

                    {/* Activities */}
                    <ul className="space-y-2">
                      {day.activities.map((activity, actIndex) => (
                        <li 
                          key={actIndex}
                          className={`flex items-start gap-2 text-zinc-400 font-manrope text-sm ${
                            index % 2 === 0 ? 'md:justify-end' : ''
                          }`}
                        >
                          {index % 2 !== 0 && <Check className="w-4 h-4 text-[#D4AF37] flex-shrink-0 mt-0.5" />}
                          <span>{activity}</span>
                          {index % 2 === 0 && <Check className="w-4 h-4 text-[#D4AF37] flex-shrink-0 mt-0.5" />}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Timeline dot - desktop only */}
                <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 w-4 h-4 rounded-full bg-[#D4AF37] border-4 border-[#111111]" />

                {/* Spacer for opposite side */}
                <div className="hidden md:block flex-1" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
